module.exports = __webpack_public_path__ + "static/deal_3-3f5a7a4d6c63b571e95fa082cb0aa5e0.png";